import type { DocumentGroup } from "services/document-group-api";

type ValidateMoveTargetParams = {
  targetPageInput: string;
  totalPages: number;
  selectedPages: Set<number>;
  documentGroups?: DocumentGroup[];
};

/**
 * validates target page input for page movement requests
 */
export const validateMoveTarget = ({
  targetPageInput,
  totalPages,
  selectedPages,
  documentGroups = [],
}: ValidateMoveTargetParams): string | null => {
  const target = parseInt(targetPageInput, 10);

  if (isNaN(target)) {
    return "Please enter a valid page number";
  }

  if (target < 1 || target > totalPages + 1) {
    return `Page number must be between 1 and ${totalPages + 1}`;
  }

  // backend rejects only when target equals one of the moved page numbers.
  if (selectedPages.has(target)) {
    if (selectedPages.size === 1) {
      const [selectedPage] = selectedPages;
      return `Page ${selectedPage} is already at this position. Choose a different position.`;
    }

    return "Cannot move pages to a position within the selected range";
  }

  // target position represents where pages will be inserted BEFORE.
  // block only positions that split a document group in the middle.
  for (const group of documentGroups) {
    if (target > group.start_pg && target <= group.end_pg) {
      return `Cannot move pages to position ${target}: it falls within the "${group.document_type}" document group (pages ${group.start_pg}-${group.end_pg})`;
    }
  }

  return null;
};
